<template>
  <div>
    <div id="item-holder">
      <div><input v-model="searchInput" placeholder="Pretraga"></div>
      <br>
      <table>
        <tr><th>datum</th><th>id</th><th>uid</th><th>ime</th><th>grad</th><th>tel</th><th>email</th><th>poruka</th><th>ukupno</th><th>opcije</th></tr>
        <tr v-for="item in filteredList" :key="item.artikli_id">
          <td>{{item.datum}}</td>
          <td>{{item.id}}</td>
          <td>{{item.uid}}</td>
          <td>{{item.ime}}</td>
          <td>{{item.grad}}</td>
          <td>{{item.tel}}</td>
          <td>{{item.email}}</td>
          <td>{{item.poruka}}</td>
          <td>{{item.ukupno}}</td>
          <td><span @click="setDisp(item)">otvori</span></td>
        </tr>
      </table>
    </div>
    <div id="displ" v-if="dispObject != null">
      <br><br>
      <span @click="dispObject=null" class="ztvr">Zatvori</span>
      <br><br>
      <p>
         Porudžba: {{dispObject.uid}}-{{dispObject.id}}<br>
         Datum: {{dispObject.datum}}<br>
         Ime: {{dispObject.ime}}<br>
         Grad: {{dispObject.grad}}<br>
         Br. tel.: {{dispObject.tel}}<br>
         Email: {{dispObject.email}}<br>
         Poruka: {{dispObject.poruka}}<br><br>
      </p>

      <table style="width:600px">
        <tr v-for="(item) in dispObject.artikli" :key="item.id">
          <td style="height:40px; width:70px; border-bottom:1px solid #aaa;"><a :href="item.url"><img :src="item.img" :alt="item.naziv" style="height:100%;position:relative"></a></td>
          <td style="height:40px; width:400px; border-bottom:1px solid #aaa; text-align: left; padding: 0px 10px; font-size:13px; font-weight:500"><a :href="item.url">{{item.naziv}}<br><span style="font-size:12px; font-weight: 300">{{item.boja}}</span></a></td>
          <td style="height:40px; width:40px; border-bottom:1px solid #aaa; text-align: right"><div style="font-size: 10px; color: #a00"  v-if="item.akcija == 1">AKCIJA</div>{{item.cijena}}€</td>
          <td style="height:40px; width:20px; border-bottom:1px solid #aaa; text-align: center">{{item.kolicina}}</td>
          <td style="height:40px; width:40px; border-bottom:1px solid #aaa; text-align: right">{{item.cijena * item.kolicina}}€</td>
        </tr>
        <tr><td colspan="3" style="text-align:right; font-size: 16px; font-weight: 400;">UKUPNO</td><td colspan="2" style="font-size: 16px; font-weight: 900; text-align:right">{{dispObject.ukupno}}</td></tr>
      </table>
      <br><br>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminPor',
  components: {
  },
  data () {
    return {
      itemObject: [],
      dispObject: null,
      searchInput: ''
    }
  },
  created () {
    this.loadItem()
  },
  methods: {
    async loadItem () {
      this.itemObject = []
      const response = await fetch('https://vndnamjestaj.me/porudzbe.php')
      const data = await response.json()
      this.itemObject = data
      this.itemObject.forEach(element => {
        const nzv = element.ime ? ',' + element.ime.replace(' ', ',') : ''
        const dblj = element.tel ? ',' + element.tel : ''
        const ptt = element.email ? ',' + element.email : ''
        const konkat = element.uid + ',' + element.podkat_tagovi + nzv + dblj + ptt
        element.tagovi = konkat.toLowerCase()
      })
    },
    setDisp (item) {
      this.dispObject = item
      this.dispObject.artikli = JSON.parse(item.artikli)
    }
  },
  computed: {
    filteredList () {
      if (this.searchInput !== '') {
        var nizs = this.searchInput.toLowerCase().split(' ')
        return this.itemObject.filter(post => {
          return nizs.every(v => post.tagovi.includes(v))
        })
      } else {
        return this.itemObject
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.ztvr{
  background-color: #a00;
  color: #fff;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  cursor: pointer;
}

#displ{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  padding: 40px;
  z-index: 99999999;
  background-color: #fff;
  text-align: left;
}

#displ *{
   font-size: 1.2vw;
}

th{
  text-align: center;
  height: 3vw;
}

input{
  width: 30vw;
  padding: 0.3vw;
}

#item-holder{
  width: 67vw;
  margin: 0px auto;
  padding-top: 3vw
}

table{
  width:100%;
  text-align: left;
  padding:0px 0px 50px;
}

td{
  padding: 0.5vw;
}

td span{
  position: relative;
  margin: 0px 30px;
  cursor: pointer;
}

td:first-child{
  width: 200px;
  text-align: center;
}

td:nth-child(2){
  width: 60px;
  text-align: center;
}

td:last-child{
  text-align: right;
  width: 100px;
}

tr:nth-child(odd){
  background-color: #f2f2f2;
}

tr:hover{
  background-color: #d2d2d2;
}

</style>
